import React from 'react';
import './pages.less';
import routes from '../../route';
import { Link } from 'react-router-dom';

function PagesList() {
  return (
    <ul className="pages">
      {routes.map((route, index) => {
        return (
          <li key={index}>
            <Link to={route.path} target="_blank">
              {route.path}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

export default PagesList;
